'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PublishActions = require('conversations-core/actions/PublishActions');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (isAdmin) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === _ActionTypes2.default.SET_CURRENT_CHANNEL) {
          var state = store.getState();
          var prevChannel = state.currentChannel;
          var channel = action.payload.channel;

          var conversation = state.entities.getIn(['conversations', channel]);

          if (channel !== null && conversation) {
            var unseenCount = conversation.unseenCount;


            if (prevChannel !== channel && unseenCount > 0) {
              store.dispatch((0, _PublishActions.publishLastSeenMessage)({
                channel: channel,
                timestamp: _I18n2.default.moment().valueOf()
              }));
              store.dispatch((0, _ConversationsActions.clearUnseenCount)({ channel: channel }));
            }
          }
        }

        if (action.type === _ActionTypes2.default.RECEIVED_INCOMING_MESSAGE) {
          var currentState = store.getState();
          var _action$payload = action.payload,
              _channel = _action$payload.channel,
              message = _action$payload.message;


          var currentRole = isAdmin ? _RoleTypes2.default.REP : _RoleTypes2.default.VISITOR;
          if ((0, _ConversationalMessageModel.isConversationalMessage)(message) && (0, _ConversationalMessageModel.getFrom)(message) !== currentRole && (0, _clientSelectors.isActiveOnChannel)(currentState, _channel)) {
            // The database will merge messages that have the same timestamp.
            // The last seen timestamp must be the timestamp of the message + 1.
            store.dispatch((0, _PublishActions.publishLastSeenMessage)({
              channel: _channel,
              timestamp: (0, _PubNubMessageModel.getTimestamp)(message) + 1
            }));
            store.dispatch((0, _ConversationsActions.clearUnseenCount)({ channel: _channel }));
          }
        }

        if (action.type === _ActionTypes2.default.APP_IN_FOREGROUND) {
          var _store$getState = store.getState(),
              currentChannel = _store$getState.currentChannel,
              entities = _store$getState.entities;

          var unseen = entities.getIn(['conversations', currentChannel, 'unseenCount']);
          if (unseen > 0) {
            store.dispatch((0, _PublishActions.publishLastSeenMessage)({
              channel: currentChannel,
              timestamp: _I18n2.default.moment().valueOf()
            }));
            store.dispatch((0, _ConversationsActions.clearUnseenCount)({ channel: currentChannel }));
          }
        }

        return next(action);
      };
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/LastSeenMiddleware.js
// module id = 482
// module chunks = 0